'use es6';

import http from 'hub-http/clients/apiClient';
import formatWebinars from '../formatters/formatWebinars';
import formatSettings from '../formatters/formatSettings';
const BASE_URI = 'gotowebinar/v1/webinars/all-synced';
export const createGetWebinars = ({
  httpClient
}) => () => httpClient.get(BASE_URI).then(formatWebinars);
export const getWebinars = createGetWebinars({
  httpClient: http
});
export const createGetSettings = ({
  httpClient
}) => () => httpClient.get('gotowebinar/v1/settings').then(formatSettings);
export const getSettings = createGetSettings({
  httpClient: http
});